import ConfigRepository from './ConfigRepository';

export default ConfigRepository;
